module.exports = __webpack_public_path__ + "img/check_1.9691bf6d.png";